import { atom } from 'recoil'

export const modalExistWelcomeSeriesWorkflow = atom({
  key: 'WorkflowModalExistWelcomeSeriesWorkflow',
  default: {
    show: false,
    id: undefined,
    name: undefined
  }
})

export const modalWelcomeMessageNotEnabled = atom({
  key: 'WorkflowModalWelcomeMessageNotEnabled',
  default: {
    show: false
  }
})

export const modalTrustedSmsSenderCodeRequestState = atom({
  key: 'WorkflowModalTrustedSmsSenderCodeRequestState',
  default: {
    show: false
  }
})

export const modalSmsSenderState = atom({
  key: 'WorkflowModalSmsSenderState',
  default: {
    show: false,
    alias: undefined
  }
})

export const modalEditDisableState = atom({
  key: 'WorkflowModalEditDisableState',
  default: {
    show: false,
    goToStep: undefined
  }
})

export const modalUsedMessageState = atom({
  key: 'usedState',
  default: {
    show: false,
    entityName: '',
    entityType: '',
    type: undefined, // WORKFLOW_MESSAGE_TYPE_EMAIL/WORKFLOW_MESSAGE_TYPE_SMS,
    droppableId: ''
  }
})

export const modalWelcomeReactivationState = atom({
  key: 'WorkflowModalWelcomeReactivationState',
  default: {
    show: false
  }
})

export const modalFilterDetailsState = atom({
  key: 'WorkflowModalFilterDetailsState',
  default: {
    show: false,
    canEdit: false,
    id: undefined,
    type: undefined,
    name: undefined,
    description: undefined
  }
})

export const modalOptionalFilterDetailState = atom({
  key: 'WorkflowModalOptionalFilterDetailsState',
  default: {
    show: false
  }
})

export const modalInvalidFirstStepState = atom({
  key: 'WorkflowModalInvalidFirstStepState',
  default: {
    show: false,
    onSuccess: undefined
  }
})

export const modalEmailConfirmationInUseState = atom({
  key: 'workflow_modalEmailConfirmationInUseState',
  default: {
    show: false,
    entityName: undefined
  }
})
